<template>
  <VueSwiper
    v-if="hasProperties"
    ref="vueSwiper"
    :options="swiperOptions"
    class="portfolio-carousel"
    :navigation="true"
    :space-between="30"
    :watch-overflow="true"
    :allow-touch-move="false"
    :autoplay="{ delay: 5000 }"
    :breakpoints="{
      320: { slidesPerView: 2 },
      640: { slidesPerView: 3 },
      980: { slidesPerView: 4 },
    }"
    style="width: 70%"
  >
    <swiper-slide
      v-for="portfolio in portfolios"
      :key="portfolio.id"
    >
      <div
        class="carousel-card"
        :class="{'active': portfolio.id === modelValue}"
        :data-id="portfolio.id"
        @click.native="selectPortfolio(portfolio.id)"
      >
        <div class="carousel-card__inner">
          <div class="carousel-card__image">
            <img
              :src="portfolio.image"
            >
          </div>
          <div class="carousel-card__content">
            <div class="carousel-card__content-title">
              <span>{{ portfolio.name }}</span>
            </div>
            <div class="carousel-card__content-text">
              {{ portfolio.properties.length }}
              {{
                portfolio.properties.length === 1 ? 'Property' : 'Properties'
              }}
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>

      <div
        class="swiper-pagination"
      />
      <div
        class="swiper-button-prev"

        @click.native="prev()"
      />
      <div
        class="swiper-button-next"

        @click.native="next()"
      />
  </VueSwiper>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-facing-decorator'
import { PortfolioItem } from '../../middleware/PortfolioItem'
import { Swiper as VueSwiper, SwiperSlide } from 'swiper/vue'

import PropertyCard from './PropertyCard.vue'
import { lazyLoadingHack } from '../../mixins/lazyLoadingHack'
import Swiper from 'swiper'

@Component({
  name: 'PortfolioSelect',
  components: {
    VueSwiper,
    SwiperSlide,
    PropertyCard,
  },
  emits: ['update:modelValue'],
})

export default class PortfolioSelect extends Vue {
  @Prop({ required: true, type: Array }) portfolios: PortfolioItem[]
  @Prop({ type: Number }) modelValue: number
  @Ref() vueSwiper: any // really VueSwiper, but gives TS error

  get swiperInstance (): Swiper {
    return this.vueSwiper.$el.swiper
  }

  next () {
    this.swiperInstance.slideNext()
  }

  prev () {
    this.swiperInstance.slidePrev()
  }

  async mounted () {
    lazyLoadingHack()
  }

  selectPortfolio (portfolioId: number): void {
    this.$emit('update:modelValue', portfolioId)
  }

  get hasProperties (): boolean {
    return this.portfolios.some(portfolio => portfolio.properties.length)
  }
}
</script>

<style lang="scss" src="@/assets/styles/carousel-card.scss"></style>
<style lang="scss">
@import "@/assets/styles/variables.scss";

.portfolio-carousel {
  .carousel-card {
    cursor: pointer;
    height: 8.875rem;

    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }
}
</style>
